export enum PolicyType {
    MOTOR = 'motor',
    NON_MOTOR = 'non_motor'
}